/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";
import ara from "../../images/flag_of_the_Arab_League.png";

const Svg = styled.svg`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 17px;
  height: 13px;
  pointer-events: none;

  ${({ theme }) => {
    if (theme.direction === "rtl") {
      return css`
        right: 45px;
      `;
    }

    return css`
      left: 45px;
    `;
  }};
`;

type FlagProps = {
  children: React.Node
};

function Flag({ children, ...props }: FlagProps) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="640"
      height="480"
      viewBox="0 0 640 480"
      {...props}
    >
      {children}
    </Svg>
  );
}

export const RUS = () => (
  <Flag>
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#0039a6" d="M0 160.003h640V480H0z" />
      <path fill="#d52b1e" d="M0 319.997h640V480H0z" />
    </g>
  </Flag>
);

export const ENG = () => (
  <Flag>
    <defs>
      <clipPath id="clipPath8673" clipPathUnits="userSpaceOnUse">
        <rect
          fillOpacity="0.67"
          height="512"
          width="682.67"
          y="-.0000028613"
          x="-85.333"
        />
      </clipPath>
    </defs>
    <g
      clipPath="url(#clipPath8673)"
      transform="matrix(.93750 0 0 .93750 80 .0000026825)"
    >
      <g
        strokeWidth="1pt"
        transform="matrix(17.067 0 0 17.067 -256 -0.0000024)"
      >
        <rect height="30" width="60" y="0" x="0" fill="#006" />
        <g>
          <path
            d="m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z"
            fill="#fff"
          />
          <path d="m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z" fill="#fff" />
          <path d="m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z" fill="#c00" />
          <path
            d="m0 30 20-10h4.472l-20 10h-4.472zm0-30 20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10 20-10h4.472l-20 10h-4.472zm24.472 20-20-10h4.472l15.528 7.764v2.236z"
            fill="#c00"
          />
        </g>
      </g>
    </g>
  </Flag>
);

export const THA = () => (
  <Flag>
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#fff" d="M0 0h640v480H0z" />
      <path fill="#001b9a" d="M0 162.544h640v160.003H0z" />
      <path fill="#e70000" d="M0 .042h640v82.5H0zM0 400.003h640v80H0z" />
    </g>
  </Flag>
);

export const VNM = () => (
  <Flag>
    <defs>
      <clipPath id="clipPath4024" clipPathUnits="userSpaceOnUse">
        <rect
          fillOpacity="0.67"
          height="512"
          width="682.67"
          y=".0000024116"
          x="-85.334"
        />
      </clipPath>
    </defs>
    <g
      id="flag"
      fillRule="evenodd"
      clipPath="url(#clipPath4024)"
      transform="matrix(.9375 0 0 .9375 80.001 -.0000022609)"
    >
      <rect
        height="512"
        width="768"
        y=".0000024116"
        x="-128"
        strokeWidth="1pt"
        fill="#ec0015"
      />
      <path
        d="m349.59 381.05-89.576-66.893-89.137 67.55 33.152-109.77-88.973-67.784 110.08-0.94507 34.142-109.44 34.873 109.19 110.08 0.14401-88.517 68.423 33.884 109.53z"
        strokeWidth=".11287"
        fill="#ff0"
      />
    </g>
  </Flag>
);

export const PHL = () => (
  <Flag>
    <path fill="#0038a8" d="M0 0h640v240H0z" />
    <path fill="#ce1126" d="M0 240h640v240H0z" />
    <path d="M415.692 240L0 480V0" fill="#fff" />
    <g transform="translate(149.333 240) scale(5.33333)" fill="#fcd116">
      <circle r="9" />
      <g id="d">
        <g id="c">
          <g id="b">
            <path d="M-1 0l.062.062L0 0l-.938-.062z" transform="scale(19)" />
            <path
              id="a"
              d="M-.884.116l.05.05L0 0z"
              transform="scale(19.2381)"
            />
            <use height="100%" width="100%" transform="scale(1 -1)" />
          </g>
          <use height="100%" width="100%" transform="rotate(45)" />
        </g>
        <use height="100%" width="100%" transform="rotate(90)" />
      </g>
      <use height="100%" width="100%" transform="scale(-1)" />
      <g transform="translate(-2.02)">
        <g id="f" transform="translate(37.962)">
          <path
            id="e"
            d="M5 0L1.618 1.176l-.073 3.58-2.163-2.854-3.427 1.037L-2 0z"
          />
          <use height="100%" width="100%" transform="scale(1 -1)" />
        </g>
        <use height="100%" width="100%" transform="rotate(120)" />
        <use height="100%" width="100%" transform="rotate(-120)" />
      </g>
    </g>
  </Flag>
);

export const IDN = () => (
  <Flag
    xmlns="http://www.w3.org/2000/svg"
    height="480"
    width="640"
    viewBox="0 0 640 480"
  >
    <g fillRule="evenodd" strokeWidth="1pt">
      <path fill="#e70011" d="M0 0h639.958v248.947H0z" />
      <path fill="#fff" d="M0 240h639.958v240H0z" />
    </g>
  </Flag>
);

export const HIN = () => (
  <Flag
    xmlns="http://www.w3.org/2000/svg"
    height="900"
    width="1350"
    viewBox="0 0 225 150"
  >
    <rect width="225" height="150" fill="#f93" />
    <rect width="225" height="50" y="50" fill="#fff" />
    <rect width="225" height="50" y="100" fill="#128807" />

    <g transform="translate(112.5,75)">
      <circle r="20" fill="#008" />
      <circle r="17.5" fill="#fff" />
      <circle r="3.5" fill="#008" />
      <g id="d">
        <g id="c">
          <g id="b">
            <g id="a">
              <circle
                r="0.875"
                fill="#008"
                transform="rotate(7.5) translate(17.5)"
              />
              <path
                fill="#008"
                d="M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z"
              />
            </g>
            <use xlinkHref="#a" transform="rotate(15)" />
          </g>
          <use xlinkHref="#b" transform="rotate(30)" />
        </g>
        <use xlinkHref="#c" transform="rotate(60)" />
      </g>
      <use xlinkHref="#d" transform="rotate(120)" />
      <use xlinkHref="#d" transform="rotate(-120)" />
    </g>
  </Flag>
);

export const ESP = () => (
  <Flag
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="20"
    viewBox="0 0 30 20"
  >
    <rect width="30" height="20" fill="#c60b1e" />
    <rect width="30" height="10" transform="translate(0 5)" fill="#ffc400" />
  </Flag>
);

export const CHN = () => (
  <Flag
    xmlns="http://www.w3.org/2000/svg"
    width="900"
    height="600"
    viewBox="0 0 30 20"
  >
    <defs>
      <path
        id="s"
        d="M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z"
        fill="#ffde00"
      />
    </defs>
    <rect width="30" height="20" fill="#de2910" />
    <use xlinkHref="#s" transform="translate(5,5) scale(3)" />
    <use xlinkHref="#s" transform="translate(10,2) rotate(23.036243)" />
    <use xlinkHref="#s" transform="translate(12,4) rotate(45.869898)" />
    <use xlinkHref="#s" transform="translate(12,7) rotate(69.945396)" />
    <use xlinkHref="#s" transform="translate(10,9) rotate(20.659808)" />
  </Flag>
);

export const TUR = () => (
  <Flag
    xmlns="http://www.w3.org/2000/svg"
    width="1200"
    height="800"
    viewBox="0 0 1200 800"
  >
    <rect width="1200" height="800" fill="#E30A17" />
    <circle cx="425" cy="400" r="200" fill="#fff" />
    <circle cx="475" cy="400" r="160" fill="#E30A17" />
    <polygon
      points="583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221"
      fill="#fff"
    />
  </Flag>
);

export const ARA = () => <Svg as="img" src={ara} alt="" />;



// WEBPACK FOOTER //
// ./src/components/Navigation/IconsLanguage.js